
import { supabase } from "@/integrations/supabase/client";
import { v4 as uuidv4 } from "uuid";
import { EmployeeInvitationData, InvitationResponse } from "../employeeTypes";
import { useAuthStore } from "@/store/authStore";

export const createEmployeeInvitation = async (
  invitationData: EmployeeInvitationData
): Promise<InvitationResponse> => {
  try {
    // Get current user as the inviter
    const currentUser = useAuthStore.getState().user;
    if (!currentUser) {
      throw new Error("No authenticated user found");
    }

    console.log("=== INVITATION CREATION DEBUG START ===");
    console.log("Creating invitation with data:", invitationData);
    console.log("Inviter user ID:", currentUser.id);

    const token = uuidv4();
    console.log("Generated token:", token);
    console.log("Token length:", token.length);
    console.log("Token type:", typeof token);
    
    const expiresAt = new Date();
    expiresAt.setDate(expiresAt.getDate() + 7); // 7 days from now

    console.log("Token expires at:", expiresAt.toISOString());

    const insertData = {
      store_id: invitationData.storeId,
      first_name: invitationData.firstName,
      last_name: invitationData.lastName,
      email: invitationData.email,
      role: invitationData.role,
      address: invitationData.address,
      street: invitationData.street,
      street_number: invitationData.streetNumber,
      city: invitationData.city,
      postcode: invitationData.postcode,
      token,
      expires_at: expiresAt.toISOString(),
      invited_by_user_id: currentUser.id,
      accepted: false,
    };

    console.log("About to insert invitation data:", insertData);

    const { data, error } = await supabase
      .from("employee_invitations")
      .insert(insertData)
      .select()
      .single();

    if (error) {
      console.error("❌ DATABASE INSERT FAILED:", error);
      console.error("Error code:", error.code);
      console.error("Error message:", error.message);
      console.error("Error details:", error.details);
      throw error;
    }

    console.log("✅ INVITATION CREATED SUCCESSFULLY:", data);
    console.log("Saved token in DB:", data.token);
    console.log("Generated vs Saved token match:", token === data.token);
    
    // Immediately verify the token was saved by querying it back
    console.log("=== IMMEDIATE VERIFICATION ===");
    const { data: verifyData, error: verifyError } = await supabase
      .from("employee_invitations")
      .select("*")
      .eq("token", token)
      .single();
    
    if (verifyError) {
      console.error("❌ VERIFICATION FAILED:", verifyError);
    } else {
      console.log("✅ VERIFICATION SUCCESS:", verifyData);
    }
    
    // Also check what's currently in the table
    const { data: allInvitations, error: listError } = await supabase
      .from("employee_invitations")
      .select("id, token, email, created_at, accepted")
      .order("created_at", { ascending: false })
      .limit(10);
    
    console.log("Recent invitations in database:", allInvitations);
    console.log("List error:", listError);
    
    console.log("=== INVITATION CREATION DEBUG END ===");

    return {
      id: data.id,
      token: data.token,
    };
  } catch (error) {
    console.error("❌ CRITICAL ERROR in createEmployeeInvitation:", error);
    throw error;
  }
};
